export const CHARACTERS = {
  MAX: 399,
  DEFAULT: 160,
  SPECIAL_DEFAULT: 140,
  SPECIAL_MAX: 280,
  SPECIAL_MEDIUM: 153,
  LIMIT: 399,
};

export const CHARACTERS_RULES = {
  NORMAL: { regex: null, limit: 160, char_limit: 399 },
  SPECIAL: {
    regex:
      /[`¡ñÑàèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÿÄËÏÖÜŸçÇßØøÅåÆæœ'~]/,
    limit: 140,
    char_limit: 280,
  },
  LONG: { regex: /.{161,}/, limit: 153, char_limit: 399 },
};

export const CHARACTERS_RULES_RCS = {
  BASIC: { regex: null, limit: 160, char_limit: 160 },
  SINGLE: {
    regex: null,
    limit: 2000,
    char_limit: 2000,
  },
};

export const HEIGHTS = [
  {
    label: "No se especifica",
    value: "HEIGHT_UNSPECIFIED",
  },
  {
    label: "Baja (120DP)",
    value: "SHORT",
  },
  {
    label: "Media (168DP)",
    value: "MEDIUM",
  },
  {
    label: "Alta (264DP)",
    value: "TALL",
  },
];

export const ORIENTATIONS = [
  {
    label: "Selecciona una orientación",
    value: "",
  },
  {
    label: "Horizontal",
    value: "HORIZONTAL",
  },
  {
    label: "Vertical",
    value: "VERTICAL",
  },
];

export const RENAME_FIELDS_EXCELL = {
  i_sms: "SMS",
  i_rcs: "RCS",
  i_send: "Enviados",
  i_responses: "Entregados",
  i_hour: "Hora",
  Hora: "Hora",
  Enviados: "Enviados",
  Entregados: "Entregados",
  dt_message: "Fecha de Envio",
  n_amount: "Monto",
  vc_partner: "Partner",
  dt_create: "Fecha de creación",
  vc_externalname: "Campaña",
  i_campaignid: "Campaña ID",
  vc_carrier: "Carrier",
  i_programed: "Programados",
  i_delivered: "Entregados",
  vc_mask: "Máscara",
  i_errors: "Errores",
  i_total: "Total",
  n_unitprice: "Precio Unitario",
  i_basic: "RCS Básico",
  i_singles: "RCS Simple",
  i_totalsms: "Total de SMS",
  vc_period: "Periodo",
  vc_customer: "Cliente",
  i_fallback: "Fallback (SMS)",
  vc_campaign: "Campaña",
  i_contacts: "Contactos",
  partner: "Partner",
  customer: "Cliente",
  msisdn: "Telefono",
  create: "Fecha",
  carrier: "Carrier",
  shortCode: "Marcacion",
  tipo: "Tipo",
  message: "Detalles",
  delivery: "Entregados",
  status: "Estado",
  uidtransaction: "Transaccion",
  origen: "Origen",
  campaig: "Campaña",
  uid_transaction: "Transaccion",
  time_id: "Hora",
  vc_msisdn: "Telefono",
  vc_message: "Detalles",
  vc_tipo: "Tipo",
  vc_source: "Origen",
  dt_fecha: "Fecha",
  i_sent: "Enviados",
  i_deliver: "Entregados",
  i_waiting: "En Procesos",
  i_invalid: "Invalidos",
  i_readed: "Leidos",
  i_replies: "Respuestas",
  i_actions: "Acciones",
  vc_provider: "Proveedor",
  i_single: "RCS Simple",
  i_rejected: "Rechazados",
};
